import { useState } from "react";
import { faqItems } from "@/mocks/home";
import Reveal from "@/pages/home/components/Reveal";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0]?.id ?? null);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[0.75fr_1.25fr] gap-10 lg:gap-16">
          <Reveal>
            <div className="lg:sticky lg:top-24">
              <span className="text-xs tracking-widest text-accent-700 uppercase">FAQ</span>
              <h2 className="mt-3 font-heading text-2xl md:text-3xl text-foreground-950">常见问题解答</h2>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                找不到入口、装不上、打不开，这几个高频问题的答案都整理在这里，点开就能看。
              </p>
              <a
                href="#entry"
                className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors whitespace-nowrap"
              >
                回到下载入口
                <i className="ri-arrow-up-line"></i>
              </a>
            </div>
          </Reveal>

          <div className="space-y-3">
            {faqItems.map((item, i) => {
              const open = openId === item.id;
              return (
                <Reveal key={item.id} delay={i * 50}>
                  <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
                    <button
                      type="button"
                      onClick={() => toggle(item.id)}
                      aria-expanded={open}
                      className="w-full flex items-center gap-4 text-left px-5 py-4 cursor-pointer"
                    >
                      <span className="text-sm md:text-base text-foreground-900 flex-1">{item.q}</span>
                      <span className="w-7 h-7 shrink-0 rounded-md bg-background-50 border border-background-300 text-foreground-600 flex items-center justify-center">
                        <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                      </span>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ease-out ${
                        open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}